import React, { Suspense } from "react";
import styled, { keyframes } from "styled-components";
import { COLORS, FONTS, SPACING } from "../../styles/variables";

// Animación de carga
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: ${SPACING.XLARGE};
`;

const Spinner = styled.div`
  border: 3px solid ${COLORS.LIGHT_GRAY};
  border-top: 3px solid ${COLORS.BLUE_MAIN};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
  margin-bottom: ${SPACING.MEDIUM};
`;

const LoadingText = styled.p`
  color: ${COLORS.DARK_GRAY};
  font-size: ${FONTS.SIZE_MEDIUM};
  text-align: center;
  margin-bottom: ${SPACING.SMALL};
`;

const LoadingSubtext = styled.p`
  color: ${COLORS.LIGHT_GRAY};
  font-size: ${FONTS.SIZE_SMALL};
  text-align: center;
`;

const LoadingFallback = ({ message = "Cargando página..." }) => (
  <LoadingContainer>
    <Spinner />
    <LoadingText>{message}</LoadingText>
    <LoadingSubtext>Optimizando tu experiencia</LoadingSubtext>
  </LoadingContainer>
);

// Componente wrapper para Suspense con fallback personalizado
const LazyPageWrapper = ({ children, loadingMessage }) => (
  <Suspense fallback={<LoadingFallback message={loadingMessage} />}>
    {children}
  </Suspense>
);

export default LazyPageWrapper;
